<mat-form-field class="fuse-mat-dense fuse-mat-rounded min-w-52 w-full" [subscriptSizing]="'dynamic'">
  <mat-icon matPrefix svgIcon="heroicons_outline:users"></mat-icon>
  <mat-select [formControl]="usersFC"  [placeholder]="'Select users'" multiple (closed)="close()">
    <mat-option *ngFor="let user of users$ | async" [value]="user.id" [disabled]="isDisabled(user.id)">{{user.displayName}}</mat-option>
  </mat-select>
</mat-form-field>